var Paginate = (function() {
    /*"use strict"; */ // Start of use strict

    var init = function init() {
      var
        allPaginateLinks = document.querySelectorAll(".paginate-link").toArray(),
        loadingCog = document.querySelector("#upload-cog");

      allPaginateLinks.forEach(function(item) {
          item.addEventListener("click", function(event) {

            event.preventDefault();

            var topThreeNews = util.id('news');
            //Scroll to top of results or to top of the page
            //if(topThreeNews !== null) {
              $('html, body').animate({
                scrollTop: $("#results").offset().top
              }, 500);
            /*} else {
              $('html, body').animate({
                scrollTop: $("#body").offset().top
              }, 1);
            }*/

            if(loadingCog)
            {
              loadingCog.classList.remove('is-hidden');
            }

            //AJAX CALL TO CHANGE RESULTS WITHOUT RELOADING THE PAGE
            $.ajax({
                method: 'GET',
                url: item.href,
                dataType: "html",
                success: function(data) {
                  var container = document.implementation.createHTMLDocument('documentFound').documentElement;
                  container.innerHTML = data;
                  document.querySelector('#results').innerHTML = container.querySelector('#results').innerHTML;
                  init();

                  if (util.id('results__table')) {
                    Tables.init({
                        actionBtnSelector: '.b-btn--download[type="submit"]',
                        checkboxAllSelector: '#checkbox-select-all',
                        checkboxSelector: '.checkbox-select'
                    });

                    Toggables.init({
                        closeAllOnToggle: true,
                        onToggled: function onToggled(trigger, trget) {
                            trget.style.height = trget.scrollHeight + 'px';
                            trget.parentNode.style.marginBottom = trget.scrollHeight + 'px';
                        },
                        offToggled: function offToggled(trigger, trget) {
                            trget.style.height = 0;
                            trget.parentNode.style.marginBottom = 0;
                        }
                    });
                }

                  if(loadingCog)
                  {
                    loadingCog.classList.add('is-hidden');
                  }
                },
                error: function(data) {}
            });
          });
        });
    }
    return { init: init };
})();
